import InstagramIcon from './instagram-icon.svg';

export default InstagramIcon;
